<div class="library-collections-mini" [class.mobile]="isMobile">
  <div class="details">
    <div class="card-cover"></div>
    <div class="cover-block">
      <div *ngFor="let cover_id of collection.multi_cover_id; let i = index; trackBy: trackByFn"
           class="cover-item"
           [ngClass]="coverCssClasses(collection?.multi_cover_id?.length, i)">
        <on-ui-cover [cover]="coverImg(cover_id)"></on-ui-cover>
      </div>

      <div *ngIf="!collection?.multi_cover_id?.length" class="cover-item">
        <on-ui-cover [cover]="noCover"></on-ui-cover>
      </div>
    </div>
    <div class="info">
      <div class="text-block">
        <div class="subject">{{ collection?.subject?.title }}</div>
        <div [routerLink]="collectionRoute" class="title-wrap">
          <h5 class="title">{{ collection?.title }}</h5>
        </div>
        <div class="subtitle">{{'collections.text.items' | customLocale}} {{ collection?.stats?.total }}</div>
      </div>
      <span class="publish-status" [ngClass]="collection?.publish_status">
      {{ publishStatusTitle() | customLocale }}
    </span>
    </div>
    <div class="actions" *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
    </div>
  </div>
  <div class="footer" *ngIf="isMobile">
    <div class="actions">
      <ng-container *ngTemplateOutlet="actionsRef"></ng-container>
    </div>
  </div>
</div>

<ng-template #actionsRef>
  <span *ngIf="can(actions.preview)"
          class="action"
          (click)="onOpenCardInModal()">{{ 'my-library.cards-actions.view' | customLocale }}</span>
  <span *ngIf="can(actions.unpublish)"
        class="action"
        (click)="onUnPublishCollection()">{{ 'my-library.cards-actions.unpublish' | customLocale }}</span>
  <span *ngIf="can(actions.publish) && collection?.valid"
        class="action"
        (click)="onPublishCollection()">{{ 'my-library.cards-actions.publish' | customLocale }}</span>
  <span *ngIf="can(actions.restore)"
        class="action"
        (click)="onRestoreCollection()">{{ 'my-library.cards-actions.restore' | customLocale }}</span>
  <a *ngIf="can(actions.edit)"
     [href]="editCollectionUrl"
     target="_blank"
     class="action">{{ 'my-library.cards-actions.edit' | customLocale }}</a>
  <span *ngIf="can(actions.archive)"
        class="action"
        (click)="onArchiveCollection()">{{ 'my-library.cards-actions.archive' | customLocale }}</span>
</ng-template>
